import { PeripheralToggleButton } from '@/components/atoms/PeripheralToggleButton'
import { cn } from '@/utils/helpers'
import type { VideoState } from '@hooks/useVideoState'
import { DeviceSelector } from '../DeviceSelector/DeviceSelector'

type Device = {
  id: string
  label: string
}

type VideoControlsGroupProps = {
  isVideoActive: boolean
  isMicrophoneActive: boolean
  onToggleVideo: () => void
  onToggleMicrophone: () => void
  audioLevel?: number
  videoState?: VideoState
  className?: string
  isCameraPermissionDenied?: boolean
  isMicrophonePermissionDenied?: boolean
  videoInputs: Device[]
  audioInputs: Device[]
  audioOutputs: Device[]
  selectedVideoInput?: string
  selectedAudioInput?: string
  selectedAudioOutput?: string
  onVideoInputChange: (id: string) => void
  onAudioInputChange: (id: string) => void
  onAudioOutputChange: (id: string) => void
  buttonSize?: 'md' | 'lg'
}

export const VideoControlsGroup = ({
  isVideoActive,
  isMicrophoneActive,
  onToggleVideo,
  onToggleMicrophone,
  audioLevel = 0,
  videoState = 'inactive',
  className,
  isCameraPermissionDenied = false,
  isMicrophonePermissionDenied = false,
  videoInputs,
  audioInputs,
  audioOutputs,
  selectedVideoInput,
  selectedAudioInput,
  selectedAudioOutput,
  onVideoInputChange,
  onAudioInputChange,
  onAudioOutputChange,
  buttonSize = 'md'
}: VideoControlsGroupProps) => {
  return (
    <div className={cn('flex items-start gap-2', className)}>
      {/* Device Selector */}
      <DeviceSelector
        videoInputs={videoInputs}
        audioInputs={audioInputs}
        audioOutputs={audioOutputs}
        selectedVideoInput={selectedVideoInput}
        selectedAudioInput={selectedAudioInput}
        selectedAudioOutput={selectedAudioOutput}
        onVideoInputChange={onVideoInputChange}
        onAudioInputChange={onAudioInputChange}
        onAudioOutputChange={onAudioOutputChange}
        buttonSize={buttonSize}
      />

      {/* Video Control */}
      <PeripheralToggleButton
        icon="video"
        isActive={isVideoActive}
        onClick={onToggleVideo}
        videoState={videoState}
        aria-label={isVideoActive ? 'Désactiver la caméra' : 'Activer la caméra'}
        isPermissionDenied={isCameraPermissionDenied}
        buttonSize={buttonSize}
      />

      {/* Microphone Control */}
      <PeripheralToggleButton
        icon="microphone"
        isActive={isMicrophoneActive}
        onClick={onToggleMicrophone}
        audioLevel={audioLevel}
        aria-label={isMicrophoneActive ? 'Couper le micro' : 'Activer le micro'}
        isPermissionDenied={isMicrophonePermissionDenied}
        buttonSize={buttonSize}
      />
    </div>
  )
}
